import { lazy } from 'react';

export default [
    {
        path: '/hengchun-guide-v2',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'HengchunGuideLayout' */ './layout')),
    },
];
